import { BaseTypes } from '../actions/baseAction';

const initState = {
  message: null,
  data: null,
  currentUser: null,
  isOpenSubmenu: false,
};

const baseReducer = function baseReducer(state = initState, action: any) {
  const { loggingData, currentUser, isOpenSubmenu } = action;
  switch (action.type) {
    case BaseTypes.LOGGING_MESSAGE:
      return {
        ...state,
        message: loggingData.message,
      };
    case BaseTypes.SET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        currentUser
      };
    case BaseTypes.SET_IS_OPEN_SUBMENU:
      return {
        ...state,
        isOpenSubmenu: isOpenSubmenu,
      };
    default:
      return state;
  }
}

export default baseReducer;
